import { MAT_DATE_FORMATS } from '@angular/material/core';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export function createMatDateFormats(displayFormat: string): typeof MY_DATE_FORMATS {
  const normalized = (displayFormat || 'dd/MM/yyyy')
    .replace('dd', 'DD')
    .replace('yyyy', 'YYYY');

  return {
    parse: {
      dateInput: normalized,
    },
    display: {
      dateInput: normalized,
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: normalized,
      monthYearA11yLabel: 'MMMM YYYY',
    },
  };
}

export function toDateInputString(date: Date | string | null | undefined): string | null {
  if (!date) {
    return null;
  }

  if (typeof date === 'string') {
    const dateOnlyMatch = date.match(/^(\d{4}-\d{2}-\d{2})/);
    if (dateOnlyMatch) {
      return dateOnlyMatch[1];
    }
  }

  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }

  const year = parsed.getFullYear();
  const month = String(parsed.getMonth() + 1).padStart(2, '0');
  const day = String(parsed.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function toISODateString(date: Date | string | null | undefined): string | null {
  if (!date) return null;

  if (typeof date === 'string') date = new Date(date);
  if (Number.isNaN(date.getTime())) return null;

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}T00:00:00.000Z`;
}